import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { isRequired } from 'components/Questionnaires/validators';

export const QuestionTextField = ({ intl, blockId, question, className, onChange }) => {
  const [inputValue, setInputValue] = useState(question?.answer ?? question.default ?? '');

  const onInputChange = (event) => {
    setInputValue(event.target.value);
    onChange(question, event.target.value);
    return true;
  };

  useEffect(() => {
    if (inputValue) {
      onChange(question, inputValue);
    }
  }, []);

  useEffect(() => {
    if (inputValue !== question.answer) {
      setInputValue(question.answer ?? '');
    }
  }, [question.answer]);

  return (<input
    key={ `${ blockId }-${ question.id }` }
    id={ `${ blockId }-${ question.id }` }
    name={ question.id }
    value={ inputValue }
    onChange={ e => onInputChange(e) }
    placeholder={ (question.placeholder ?? question.label) ? intl.formatMessage({ id: question.placeholder ?? question.label }) : '' }
    autoComplete="no"
    className={ `${ className }${ question.isValid === false ? ' error' : '' }` }
    disabled={ question.disabled }
    required={ isRequired(question) }
    type="text"
    aria-label={ (question.placeholder ?? question.label) ? intl.formatMessage({ id: question.placeholder ?? question.label }) : '' }
    aria-required={ isRequired(question) }
    aria-describedby={ question.isValid === false ? (`${ blockId }-${ question.id }-error`) : undefined }
  />);
};

QuestionTextField.displayName = 'QuestionTextField';

QuestionTextField.propTypes = {
  blockId: PropTypes.string.isRequired,
  question: PropTypes.shape().isRequired,
  intl: PropTypes.shape().isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired
};

QuestionTextField.defaultProps = {
  className: '',
  disabled: false
};

export default QuestionTextField;
